import * as React from 'react'
import styled from '@independent-software/typeui/styles/Theme'

import { Topbar } from './Topbar'
import { Sidebar } from './sidebar/Sidebar'
import { Window } from './Window'
import { MENU } from '../config/Menu'

interface IProps {
  /** @ignore */
  className?: string;
  /** @ignore */
  children?: React.ReactNode;
  title: string;
}

const ScreenBase = (props: IProps) => {
  const [menuOpen, setMenuOpen] = React.useState(false);

  const handleToggleSidebar = () => setMenuOpen(!menuOpen);

  return (
    <div className={props.className}>
      <Sidebar open={menuOpen} onClose={handleToggleSidebar} menu={MENU}/>
      <Window open={menuOpen}>
        <Topbar 
          onMenu={handleToggleSidebar}>
          {props.title}
        </Topbar>
        <Content>
          {props.children}
        </Content>
      </Window>
    </div>
  );
}

const Content = styled.div`
  position: relative;
  overflow-y: hidden;
  overflow-x: hidden;
  flex: 1;
`;

const Screen = styled(ScreenBase)`
  /* Screen covers the entire viewport. */
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  /* Offscreen items are hidden,
     like the Window when it is shifted. */
  overflow: hidden; 
`

export { Screen }
